import { ViewableDate } from "../../models/ViewableDate";
import { getLockedBatches } from "../../services/locks/Locks";
import { useSmartTimer } from "../hooks/useSmartTimer";
import { LockState, useBatchLockDispatch } from "./contexts/GoodLockProvider";

export { BatchLockInfoTimer };

type Props = {
  batchClassId: string;
  intervalMs: number;
  debug?: boolean;
};
const BatchLockInfoTimer = (props: Props) => {
  const lockDispatch = useBatchLockDispatch();

  const [lastUpdated] = useSmartTimer(
    async (batchClassId) => await getLockedBatches(batchClassId),
    props.intervalMs,
    (batches) => {
      const newLocks = batches.reduce((prev, curr) => {
        prev[curr.checkedOutId] = [
          curr.createdBy,
          props.batchClassId,
          curr.parent == null || curr.parent == undefined,
        ];
        return prev;
      }, {} as LockState);

      lockDispatch({
        data: newLocks,
        type: "set",
      });
    },
    [props.batchClassId],
  );

  if (props.debug) {
    return (
      <span
        style={{
          display: "flex",
          flexGrow: 1,
          justifyContent: "center",
          padding: "1rem",
        }}
      >
        Last Updated:{" "}
        {lastUpdated == null
          ? "Not Synced Yet"
          : ViewableDate(lastUpdated, true)}
      </span>
    );
  } else {
    return null;
  }
};
